"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M6.5,10h-3A1.5,1.5,0,0,1,2,8.5v-3A1.5,1.5,0,0,1,3.5,4h3A1.5,1.5,0,0,1,8,5.5v3A1.5,1.5,0,0,1,6.5,10ZM4,8H6V6H4Z"/><path d="M6.5,19h-3A1.5,1.5,0,0,1,2,17.5v-3A1.5,1.5,0,0,1,3.5,13h3A1.5,1.5,0,0,1,8,14.5v3A1.5,1.5,0,0,1,6.5,19ZM4,17H6V15H4Z"/><path d="M6.5,28h-3A1.5,1.5,0,0,1,2,26.5v-3A1.5,1.5,0,0,1,3.5,22h3A1.5,1.5,0,0,1,8,23.5v3A1.5,1.5,0,0,1,6.5,28ZM4,26H6V24H4Z"/><path d="M29,8H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,8Z"/><path d="M29,17H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,17Z"/><path d="M29,26H12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29a1,1,0,0,1,1,1h0A1,1,0,0,1,29,26Z"/>';
var ListOutlineSVG = function ListOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ListOutlineSVG = ListOutlineSVG;
ListOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ListOutlineSVG);
exports.default = _default;